import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MatiereEcole from './matiere-ecole';
import MatiereEcoleDetail from './matiere-ecole-detail';
import MatiereEcoleUpdate from './matiere-ecole-update';
import MatiereEcoleDeleteDialog from './matiere-ecole-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/new`} component={MatiereEcoleUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/edit`} component={MatiereEcoleUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id`} component={MatiereEcoleDetail} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid`} component={MatiereEcole} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/delete`} component={MatiereEcoleDeleteDialog} />
  </>
);

export default Routes;
